export const isCancelled = (status = '') =>
  ['CANCELLED', 'CANCELED', 'DELETED', 'DISCONTINUED'].some((s) => status.toUpperCase().includes(s))
